import { render, staticRenderFns } from "./AddRelatedMediaModal.vue?vue&type=template&id=cc0c551e&scoped=true&"
import script from "./AddRelatedMediaModal.vue?vue&type=script&lang=js&"
export * from "./AddRelatedMediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0c551e",
  null
  
)

export default component.exports